import {makeAutoObservable, runInAction} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';
import {publishArticles} from '../api/publish-articles.ts';
import {PublishType} from '@wp-content-publisher/typings-lib/src/server/types/publish';
import {PublishFormFieldsEnum} from '@wp-content-publisher/typings-lib/src/client/enums/publish-form-fields.enum';
import {PublishInterface} from '@wp-content-publisher/typings-lib/src/client/interfaces/publish.interface';

export type PublishFormFields = Pick<PublishType, PublishFormFieldsEnum.category | PublishFormFieldsEnum.published_date>;
export type IdsData = Pick<PublishInterface, 'site_id' | 'article_id'>;

const initFormData: PublishFormFields = {
    category: '',
    published_date: '',
}

class PublishFormStore {

    formData: PublishFormFields = {...initFormData};

    submitStatus: IPromiseBasedObservable<PublishType> | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setFormData = (inputData: PublishFormFields) => {
        runInAction(() => {
            this.formData = {...this.formData, ...inputData};
        });
    }

    submitForm = async (articlesSitesIds: IdsData) => {
        this.submitStatus = fromPromise(publishArticles({
            ...this.formData,
            ...articlesSitesIds
        }));
    }

    reset = () => {
        this.formData = {...initFormData};
    }
}

const publishFormStore = new PublishFormStore();
export {publishFormStore};